export function currencySymbol(locale: string, currency: any): string | null {
    if (!currency) {
        return null;
    }
    if (!currency.custom_format) {
        const formatter = Intl.NumberFormat(locale, {
            currency: currency.code,
            style: 'currency'
        });
        return formatter.formatToParts(1).find(part => part.type === 'currency')?.value || null;
    }
    return currency.symbol;
}
